import { render, staticRenderFns } from "./FrameIcon.vue?vue&type=template&id=6de3aa70&"
import script from "./FrameIcon.vue?vue&type=script&lang=js&"
export * from "./FrameIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports